var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:['blob', `-${_vm.shape}`, { '-squish': _vm.squish }, {'-light' : _vm.light}, {'-bottom': _vm.bottom}],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.svg.viewBox}},[_c('path',{attrs:{"d":_vm.svg.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }